import CommentActivityItem from "./ActivityTypes/CommentActivityItem";
import TransferActivityItem from "./ActivityTypes/TransferActivityItem";

export const activityComponentMapping = {
  ADD_COMMENT: CommentActivityItem,
  TRANSFER_DOCUMENT_OUT: TransferActivityItem,
};

export default activityComponentMapping;
